'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { useAvailability } from './useAvailability';

type AvailabilityState = ReturnType<typeof useAvailability>;

const AvailabilityContext = createContext<AvailabilityState | null>(null);

type AvailabilityProviderProps = {
  propertyId: string;
  initialBlocked?: { start: string; end: string; source: 'booking' | 'ical' | 'manual' }[];
  initialMinNightOverrides?: { start: string; end: string; minNights: number }[];
  months?: number;
  refreshMs?: number;
  deferMs?: number;
  children: ReactNode;
};

export function AvailabilityProvider({
  propertyId,
  initialBlocked,
  initialMinNightOverrides,
  months,
  refreshMs,
  deferMs,
  children,
}: AvailabilityProviderProps) {
  const availability = useAvailability({
    propertyId,
    initialBlocked,
    initialMinNightOverrides,
    months,
    refreshMs,
    deferMs,
  });

  return <AvailabilityContext.Provider value={availability}>{children}</AvailabilityContext.Provider>;
}

export function useAvailabilityContext() {
  return useContext(AvailabilityContext);
}
